import { render, staticRenderFns } from "./ISF.vue?vue&type=template&id=0a05c78a&"
import script from "./ISF.vue?vue&type=script&lang=js&"
export * from "./ISF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports